import React from "react";

const deriveAltFromSrc = (src) => {
  if (!src) return "image";
  try {
    const parts = src.split("/").pop().split("?")[0].split("#")[0];
    const name = parts.replace(/\.[^/.]+$/, "").replace(/[-_\.]/g, " ");
    const cleaned = name.replace(/\s+/g, " ").trim();
    return cleaned.replace(/(^\w)|\s(\w)/g, (m) => m.toUpperCase());
  } catch (e) {
    return "image";
  }
};

const LazyImg = ({
  src,
  alt,
  className,
  loading = "lazy",
  width,
  height,
  srcSet,
  sizes,
  style,
  onLoad,
  ...props
}) => (
  <img
    src={src}
    alt={alt || deriveAltFromSrc(src)}
    className={className}
    loading={loading}
    width={width}
    height={height}
    srcSet={srcSet}
    sizes={sizes}
    style={style}
    onLoad={onLoad}
    {...props}
  />
);

export default LazyImg;
